"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobDeliveryDateWithForcast = void 0;
const typeorm_1 = require("typeorm/browser");
let JobDeliveryDateWithForcast = class JobDeliveryDateWithForcast {
};
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'job_api_id' }),
    __metadata("design:type", String)
], JobDeliveryDateWithForcast.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'delivery_date' }),
    __metadata("design:type", Date)
], JobDeliveryDateWithForcast.prototype, "deliveryDate", void 0);
JobDeliveryDateWithForcast = __decorate([
    (0, typeorm_1.ViewEntity)({
        name: 'job_delivery_date_with_forcast',
        schema: 'analytics',
        materialized: true,
        expression: `
    SELECT DISTINCT ON (j.api_id__c)
      j.api_id__c AS job_api_id,
      CASE
        WHEN j.date_end__c IS NOT NULL THEN j.date_end__c::TIMESTAMPTZ AT TIME ZONE 'UTC'
        WHEN j.appointment_customer_end__c IS NOT NULL THEN j.appointment_customer_end__c::TIMESTAMPTZ AT TIME ZONE 'UTC'
        ELSE
          (
            SELECT
              CASE
                WHEN time_stamp < (NOW()) THEN (NOW() + INTERVAL '1 week')
                ELSE time_stamp
              END +
              (
                SELECT
                  AVG(
                    jlogfinish.date_end__c - (
                      SELECT logstatus.time_stamp
                      FROM log_entries logstatus
                      WHERE logstatus.job_api_id = jlogfinish.api_id__c
                      AND logstatus.new_status = j.status__c
                      AND logstatus.event_type = 'new_status'
                      ORDER BY logstatus.time_stamp ASC
                      LIMIT 1
                    )
                  )
                FROM
                  public.job__c jlogfinish
                LEFT JOIN materialized_job_types jlogfinish_mjt ON
                  jlogfinish_mjt.job_api_id = j.api_id__c
                WHERE
                  jlogfinish.opportunity__c = j.opportunity__c
                  AND jlogfinish.status__c IN ('finished', 'approval pending', 'completed', 'invoice sent')
                  AND jlogfinish.date_end__c IS NOT NULL
                  AND JSON_BUILD_OBJECT(
                    'installation', mjt.installation,
                    'precheck', mjt.precheck,
                    'activation', mjt.activation,
                    'remote', mjt.remote,
                    'hardware_sale', mjt.hardware_sale,
                    'maintenance', mjt.maintenance,
                    'planning', mjt.planning,
                    'customer_sign_required', mjt.customer_sign_required,
                    'async_appointment', mjt.async_appointment,
                    'meter_application', mjt.meter_application,
                    'installation_preparation', mjt.installation_preparation,
                    'defect_elimination', mjt.defect_elimination
                  )::TEXT = JSON_BUILD_OBJECT(
                    'installation', jlogfinish_mjt.installation,
                    'precheck', jlogfinish_mjt.precheck,
                    'activation', jlogfinish_mjt.activation,
                    'remote', jlogfinish_mjt.remote,
                    'hardware_sale', jlogfinish_mjt.hardware_sale,
                    'maintenance', jlogfinish_mjt.maintenance,
                    'planning', jlogfinish_mjt.planning,
                    'customer_sign_required', jlogfinish_mjt.customer_sign_required,
                    'async_appointment', jlogfinish_mjt.async_appointment,
                    'meter_application', jlogfinish_mjt.meter_application,
                    'installation_preparation', jlogfinish_mjt.installation_preparation,
                    'defect_elimination', jlogfinish_mjt.defect_elimination
                  )::TEXT
              )
            FROM log_entries
            WHERE job_api_id = j.api_id__c
            AND new_status IS NOT NULL
            AND event_type = 'new_status'
            ORDER BY time_stamp DESC
            LIMIT 1
          )::TIMESTAMPTZ AT TIME ZONE 'UTC'
      END AS delivery_date
    FROM public.job__c j
    LEFT JOIN materialized_job_types mjt ON
      mjt.job_api_id = j.api_id__c
    WHERE j.status__c NOT IN ('cancelled', 'closed')
  `,
    })
], JobDeliveryDateWithForcast);
exports.JobDeliveryDateWithForcast = JobDeliveryDateWithForcast;
//# sourceMappingURL=materialized-job-delivery-date-with-forecast.js.map